/**
@ngdoc directive
@name xmsDatepicker

@description
The new datepicker meant to replace <xms-datepicker> (restrict: E) directive.

@param {boolean=} timezoneUtc prevents datetime timezone conversion

@usage
<input xms-datepicker .... />
<!-- Please see testUi (former testValidation) for multiple examples -->

*/
(function() {

    'use strict';


var xmsNewDatepicker = function($compile, $timeout, $filter){

    return({
        restrict: "A",
        scope: true, // it cannot be isolated scope as it will break multiactionModel
        template: function(tElement, tAttributes){
            if( angular.isDefined(tAttributes.timezoneUtc) && tAttributes.timezoneUtc=="true"){
                angular.element(tElement[0]).attr('ng-model-options',"{ updateOn: 'default blur', debounce: { default: 1000, blur: 0 }, timezone: 'UTC' }");
            }
        },
        bindToController: {
            init: '&',
            ngModel:'=',
            ngDisabled:"=?",
            ngReadonly:'=?',
            timezoneUtc:"@"
        },
        controllerAs: 'ctrlDatepicker',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            var _this = this;
            $scope.hiddenGrails = new Object();

            // for Grails Framework only
            _this.parseDateGrails = function(date) {
                var hiddenGrails = {};
                if(!isNaN(date) && date!=null && date!="") {
                    hiddenGrails.year    = date.getFullYear();
                    hiddenGrails.month   = date.getMonth();
                    hiddenGrails.day     = date.getDate();
                    hiddenGrails.month++;
                }
                return hiddenGrails;
            }

            // Formating the date from server side ISO to javascript date (X3-8158)
            $scope.toDate = function(date){
                if(date){
                    return new Date(date);
                }
            };

            _this.calcFixedModel = function(ngModel){
                return (!angular.isDefined(ngModel) || ngModel instanceof Date) ? ngModel : new Date( this.timezoneUtc=='true'? ngModel : ngModel.replace(/-/g, '/') );
            }

            $scope.$watch(
                function(){
                    return _this.ngModel;
                },
                function(newVal, oldVal){
                    $scope.hiddenGrails = _this.parseDateGrails(_this.ngModel);
                }
            );

            $scope.clearModel = function(){
                _this.ngModel = undefined;
            }

        }],
        require: 'xmsDatepicker',
        compile: compile
    });


    function compile( tElement, tAttributes ) {

        if(tElement[0].tagName!='INPUT'){
            throw "Error: xms-datepicker (new version, restrict A) can be only applied on input element.";
        }


        // store the content of the directive in the variable then remove it
        // var htmlContent = tElement.html();
        // tElement.html(''); // remove
        var outerHtml = tElement[0].outerHTML;

        return function postLink(scope, element, attrs, ctrl) {

            // this had to be moved from the controller, otherwise the (uib)datepicker wouldn't retain invalid $viewValue (kinda $viewValue)
            $timeout(function(){
                if(ctrl.init()!="" && ctrl.init()!=null){
                    ctrl.ngModel = ctrl.calcFixedModel(ctrl.init());
                }
                // init is now dynamic
                scope.$watch(
                    function(){
                        return ctrl.init();
                    },
                    function(newVal, oldVal){
                        if(newVal != oldVal && newVal != null){
                            ctrl.ngModel = ctrl.calcFixedModel(newVal);
                        }
                    }
                );
            });


            (function initialize(){

                scope.dotFix = {
                    isOpen : false
                }

                // for easier manipulation
                var $html = $('<div></div>');
                $html.append(outerHtml);
                $html.addClass('input-group');

                var input     = $html.find('input');
                var inputName = input.attr('name');
                var inputId   = input.attr('id')!='' ? input.attr('id') : inputName;

                if( angular.isDefined(input.attr('xms-validation')) ){
                    input.removeAttr('xms-validation'); // uib-datepicker won't allow that on the same element (isolated scope)
                    $html.attr('xms-validation','');
                    // custom validation messages
                    if( angular.isDefined(input.attr('validation-messages')) ){
                        $html.attr('validation-messages', input.attr('validation-messages'));
                        input.removeAttr('validation-messages');
                    }
                }
                if( angular.isDefined(input.attr('disabled')) ){ // TODO: change to attrs?
                    ctrl.ngDisabled = true;
                }
                if( angular.isDefined(input.attr('readonly')) ){ // TODO: change to attrs?
                    ctrl.ngReadonly = true;
                }

                // dynamic validation plus custom messages fix
                if( !angular.isDefined(attrs.max) ){
                    if( angular.isDefined(attrs.ngMax) ){
                        // we need that Chrome year more than 4 digits fix, so we cannot just do:
                        // input.attr('max', '{{'+attrs.ngMax+'}}');
                        // the following works! we just need to make sure there's only model without filters in ng-max/ng-min everywhere
                        // input.attr('max','{{('+ attrs.ngMax+' != undefined) ? ('+ attrs.ngMax +' | date : "yyyy-MM-dd") : "9999-12-31"}}' );

                        if(!cssua.ua.edge || cssua.ua.edge >= 17) {
                            input.attr('max','{{watchedNgMax}}'); // this makes Edge 16 crash
                            // the following perhaps could be migrated into ngMax extending directive? (new ngMax with priority set)
                            scope.$watch(
                                function(){
                                    return attrs.ngMax;
                                },
                                function(newVal, oldVal){
                                    if(newVal!=oldVal){
                                        scope.watchedNgMax = '9999-12-31'; // '9999-12-31' fixes more than 4 digits appearing in year problem on Chrome
                                        if(angular.isDefined(newVal) && newVal!='') {
                                            scope.watchedNgMax = (newVal instanceof Date) ? $filter('date')(newVal, 'yyyy-MM-dd') : newVal;
                                        }
                                    }
                                }
                            );
                        }
                    } else if(cssua.ua.chrome) { // more than 4 digits appearing in year - Chrome fix
                        input.attr('max', '9999-12-31');
                    }
                }
                // dynamic validation plus custom messages fix
                if( !angular.isDefined(attrs.min) && angular.isDefined(attrs.ngMin) ){
                    input.attr('min', '{{'+attrs.ngMin+'}}');
                }


                input
                    .attr('id',   inputId   + '_display' ) // for Grails
                    .attr('name', inputName + '_display' ) // for Grails
                    .attr('placeholder',"yyyy-mm-dd")
                    .attr('maxmonths','')
                    .removeAttr('xms-datepicker');

                if(!cssua.ua.edge){
                    // MS Edge will use default datepicker as it's not possible to remove it and we still would like to take an advantage of input type=date features (ie. Angular native validation)
                    input
                        .attr('uib-datepicker-popup',"")
                        .attr('datepicker-options', '{showWeeks:false, startingDay:1}')
                        .attr('is-open',"dotFix.isOpen")
                        .attr('close-text',"Close");
                }


                // for Grails (this needs to go before input-group-btn, so bootstrap css .input-group-btn:last-child>.btn-group can work)
                $html.append([
                    '<input type="hidden" name="'+inputName+'" value="date.struct" >',
                    '<input type="hidden" name="'+inputName+'_year" value="{{hiddenGrails.year}}">',
                    '<input type="hidden" name="'+inputName+'_month" value="{{hiddenGrails.month}}">',
                    '<input type="hidden" name="'+inputName+'_day" value="{{hiddenGrails.day}}">'
                    ].join('')
                );

                if(!cssua.ua.edge){
                    $html.append([
                        '<span ng-show="!ctrlDatepicker.ngDisabled && !ctrlDatepicker.ngReadonly" class="input-group-btn">',
                            '<button type="button" class="btn btn-default" ng-click="dotFix.isOpen ? dotFix.isOpen=false : dotFix.isOpen=true" aria-label="Open Calendar">',
                                '<i class="glyphicon glyphicon-calendar"></i>',
                            '</button>',
                        '</span>',
                        '<span ng-if="ctrlDatepicker.ngDisabled || ctrlDatepicker.ngReadonly" class="input-group-prepend"><span class="input-group-text"><i class="glyphicon glyphicon-calendar"></i></span></span>'
                    ].join('')
                );
                } else {
                    $html.prepend('<div class="input-group-prepend"><span class="input-group-text"><span class="glyphicon glyphicon-calendar"></span></span></div>');
                    $html.append('<a ng-click="clearModel()" title="Clear Date" href="javascript:void(0);" class="clear-field" ng-hide="ctrlDatepicker.ngModel===undefined">&times;<a>');
                }


                element.after( $html[0].outerHTML );
                var newElement = element.next();
                element.remove();

                $compile( newElement )(scope);

                // grails label for parameter change to match the id
                newElement.parent().find('[for="'+inputId+'"]').attr('for', inputId+'_display');

            })(); // () - executes on declaration

        }
    }
}
xmsNewDatepicker.$inject = ['$compile', '$timeout', '$filter'];
angular.module('app').directive('xmsDatepicker', xmsNewDatepicker);


}());